var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
// import { useExperiment } from 'shop/context/ExperimentsContext';
import ProductDetails from './ProductDetails';
// import ProductDetailsABTest from './ProductDetailsABTest';
import { ProductDetailsFragment } from './ProductDetails.gql';
/**
 * This wrapper component conditionally renders Product Details based on the A/B test variation bucketing.
 * It serves as the main entry point for Product Details and handles experiment-driven variations.
 */
var ProductDetailsContainer = function (props) { return (
/**
 * If there is an active ProductDetails test, uncomment the imports (useExperiment and the ABTest component) and then render the AB test component.
 * Otherwise, render the original ProductDetails component.
 *
 * Example:
 *   const experimentVariation = useExperiment('PDP_PACK_SLIDER_V2');
 *   if (experimentVariation === 'variant') {
 *     return <ProductDetailsABTest {...props} />;
 *   }
 */
React.createElement(ProductDetails, __assign({}, props))); };
ProductDetails.displayName = 'ProductDetails';
ProductDetails.fragment = ProductDetailsFragment;
export default ProductDetailsContainer;
